import { globalAuthApi } from 'api';

const mutate: Record<string, any> = {
  auth: {
    niceVerifyPrev: globalAuthApi.niceVerifyPrev,
    niceVerify: globalAuthApi.niceVerify,
    // duplicateCheck: globalAuthApi.duplicateCheck,
  },
};

export default mutate;
